/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_Group_HelpInputs */

const en_portalframe_group_help = /** @type {(inputs: Portalframe_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help and account`)
};

/** @type {(inputs: Portalframe_Group_HelpInputs) => LocalizedString} */
const ar_portalframe_group_help = en_portalframe_group_help;

/** @type {(inputs: Portalframe_Group_HelpInputs) => LocalizedString} */
const he_portalframe_group_help = en_portalframe_group_help;

/** @type {(inputs: Portalframe_Group_HelpInputs) => LocalizedString} */
const ur_portalframe_group_help = en_portalframe_group_help;

/** @type {(inputs: Portalframe_Group_HelpInputs) => LocalizedString} */
const es_portalframe_group_help = en_portalframe_group_help;

/** @type {(inputs: Portalframe_Group_HelpInputs) => LocalizedString} */
const fr_portalframe_group_help = en_portalframe_group_help;

/** @type {(inputs: Portalframe_Group_HelpInputs) => LocalizedString} */
const de_portalframe_group_help = en_portalframe_group_help;

/** @type {(inputs: Portalframe_Group_HelpInputs) => LocalizedString} */
const pt_portalframe_group_help = en_portalframe_group_help;

/** @type {(inputs: Portalframe_Group_HelpInputs) => LocalizedString} */
const hi_portalframe_group_help = en_portalframe_group_help;

/** @type {(inputs: Portalframe_Group_HelpInputs) => LocalizedString} */
const bn_portalframe_group_help = en_portalframe_group_help;

/**
* | output |
* | --- |
* | "Help and account" |
*
* @param {Portalframe_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_group_help = /** @type {((inputs?: Portalframe_Group_HelpInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_Group_HelpInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_group_help(inputs)
	if (locale === "he") return he_portalframe_group_help(inputs)
	if (locale === "ur") return ur_portalframe_group_help(inputs)
	if (locale === "es") return es_portalframe_group_help(inputs)
	if (locale === "fr") return fr_portalframe_group_help(inputs)
	if (locale === "de") return de_portalframe_group_help(inputs)
	if (locale === "pt") return pt_portalframe_group_help(inputs)
	if (locale === "hi") return hi_portalframe_group_help(inputs)
	if (locale === "bn") return bn_portalframe_group_help(inputs)
	return /** @type {LocalizedString} */ ("Help and account")
});